export default "/react/logoSmartWidgets-c5180ba9.png";